import FuelApproval from './FuelApproval'
import FuelCard from './components/FuelCard/FuelCard'

export { FuelApproval, FuelCard as FuelCardAdmin }
